// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 38335 ? "auth-suite-store" : chunkId) + "-" + {"38335":"92eb0f373a95977951ba","46528":"7636518e67ad66be62ca"}[chunkId] + ".min.js";
};